export default __webpack_public_path__ + "static/media/GoogleDriveIcon.32152222.svg";